import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router-dom";
import { NavLink } from "../../common/components";
import { AppToolbarContext } from "../../context/AppToolbar";
import ProjectService from "../../service/ProjectService";
import TeamService from "../../service/TeamService";
import { spacing } from "../../styles/theme";
import { ROUTES } from "../../constant/common.constant";
import { useAppLoading } from "../../context/AppLoading/useAppLoading";
import { toast } from "react-toastify";
import { useTeam } from "../../context/Team";

export const AddTeamNavItem = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setIsAppLoading } = useAppLoading();
  const { toggleNavigationDrawerOpen } = useContext(AppToolbarContext);

  const { refetchTeams, teams } = useTeam();

  const onClick = useCallback(async () => {
    setIsAppLoading(true);
    try {
      const bodyData = {
        name: `${t("team.team")} ${teams?.length + 1}`,
      };

      const {
        data: {
          data: { id },
        },
      } = await TeamService.createTeam(bodyData);

      const projectBodyData = {
        baseName: `${t("project.project")}`,
        teamId: id,
      };

      await ProjectService.createProject(projectBodyData);

      await refetchTeams({ skipLoading: true });
      navigate(generatePath(ROUTES.TEAM, { teamId: id }));
      toggleNavigationDrawerOpen?.();
    } catch (error) {
      toast.error(t("team.create_team_error"));
    } finally {
      setIsAppLoading(false);
    }
  }, [
    setIsAppLoading,
    t,
    teams.length,
    refetchTeams,
    navigate,
    toggleNavigationDrawerOpen,
  ]);

  return (
    <NavLink
      to=""
      startIcon="create_new_folder"
      content={t("navigation.new_team")}
      onClick={onClick}
      style={{ paddingRight: spacing.mediumDesktop }}
      data-test="leftNavigation.createTeam"
    />
  );
};
